import React, { useEffect } from 'react';
import { services } from '../../API';
import { store } from '../../store';
import { PrivacyPolicy } from './PrivacyPolicy';

interface UserInitializerProps {
  children: React.ReactNode;
}

export const AuthInitializer = ({ children }: UserInitializerProps) => {
  useEffect(() => {
    (async () => {
      services.auth.subscribeOnLogin(store.user.load);
      services.auth.subscribeOnLogout(store.user.clear);

      await services.auth.loginByRefreshToken();
    })();

    return () => {
      services.auth.unsubscribeOnLogin(store.user.load);
      services.auth.unsubscribeOnLogout(store.user.clear);
    };
  }, []);

  return (
    <>
      {children}
      <PrivacyPolicy />
    </>
  );
};
